import React from "react";
import './list.css';


const ListItem = ({
  item: {
    title,
    profession,
    description,
    location,
    experience,
    date,
    image,
  },
}) => (
  <>
    <div className="doctor-list">
      <div className="list-box">
        <span className="list-span-1">
          <img src={image} alt="" className="list-box-img" />
        </span>
        <span className="list-span-2">
          <h2>{title}</h2>
          <h3>{profession}</h3>
          <p>{description}</p>
          <button>View More</button>
          <i class="fa-solid fa-heart view-icon"></i>
        </span>
        <span className="list-span-3">
          <p>
            <i class="fa-solid fa-location-dot doc-icons"></i> {location}
          </p>
          <p className="list-span-3-p2">
            <i class="fa-sharp fa-solid fa-briefcase-medical doc-icons"></i>
            {experience}
          </p>
          <p className="list-span-3-p3">
            <i class="fa-solid fa-calendar doc-icons"></i>
            {date}
          </p>
          <span className="list-span-3-icons">
          </span>
        </span>
      </div>

    </div>

  </>
);

export default ListItem;
